import React from "react";
import VideoPlayerWithThumbnail from "./VideoPlayerWithThumbnail";

const HelpSection = ({
  tittle = "",
  videoUrl = "",
  thumbnailUrl = "",
  media_content = "",
}) => {
  return (
    <>
      <div class="we-help-section ">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 mb-5 mb-lg-0">
              <div class="ct_video_thumb mx-auto text-center">
                {videoUrl && (
                  <VideoPlayerWithThumbnail
                    videoUrl={videoUrl}
                    thumbnailUrl={thumbnailUrl}
                  />
                )}
              </div>
            </div>
            <div class="col-lg-6 ps-lg-5">
              {tittle && (
                <h2 class="section-title mb-4">
                  <strong>{tittle}</strong>
                </h2>
              )}
              <div
                className="ct_head_para_text_12"
                dangerouslySetInnerHTML={{ __html: media_content }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpSection;
